import React from 'react';

import { DataCard } from './DataCard';

import { displayMoney } from '../utils/displayMoney';

import type { GeneralProps } from '../type';

type Props = {
  general: GeneralProps;
};

export const ListCard: React.FC<Props> = ({ general }) => (
  <div className="shrink-0 grid grid-cols-1 tablet:grid-cols-2 sm-desktop:grid-cols-3 gap-xs">
    <DataCard title="CDP" timeData="week">
      <div className="text-h5 lg-desktop:text-h4">
        <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
          {general.nb_mer_cdp_sem}{' '}
        </span>
        leads avec leur première <span className="font-bold">consultation </span>
      </div>
    </DataCard>
    <DataCard title="CDPL" timeData="week">
      <div className="text-h5 lg-desktop:text-h4">
        <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
          {general.nb_mer_cdpl_sem}{' '}
        </span>
        leads avec leur première <span className="font-bold">consultation </span>
      </div>
    </DataCard>
    <DataCard title="Club pro" timeData="month">
      <div className="text-h5 lg-desktop:text-h4">
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.mrr_club_pro)}
          </span>{' '}
          de MRR
        </div>
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {general.nb_clients_club_pro}
          </span>{' '}
          clients à date
        </div>
      </div>
    </DataCard>
    <DataCard
      title="CDP"
      timeData="month"
      subTitle={
        <>
          Objectif revenus:{' '}
          <span className="text-brand font-bold">{displayMoney(general.obj_rev_cdp)}</span>
        </>
      }
      secondSubTitle={
        <>
          Objectif GMV:{' '}
          <span className="text-brand font-bold">{displayMoney(general.obj_gmv_cdp)}</span>
        </>
      }
    >
      <div className="text-h5 lg-desktop:text-h4">
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.revenus_cdp_mois)}
          </span>{' '}
          de revenus
        </div>

        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.gmv_cdp_mois)}
          </span>{' '}
          de GMV
        </div>
        <div>
          {' '}
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {general.take_rate_cdp?.toFixed(1)}%
          </span>{' '}
          Take rate
        </div>
      </div>
    </DataCard>
    <DataCard
      title="CDPL"
      timeData="month"
      subTitle={
        <>
          Objectif revenus:{' '}
          <span className="text-brand font-bold">{displayMoney(general.obj_rev_cdpl)}</span>
        </>
      }
      secondSubTitle={
        <>
          Objectif GMV:{' '}
          <span className="text-brand font-bold">{displayMoney(general.obj_gmv_cdpl)}</span>
        </>
      }
    >
      <div className="text-h5 lg-desktop:text-h4">
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.revenus_cdpl_mois)}
          </span>{' '}
          de revenus
        </div>
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.gmv_cdpl_mois)}
          </span>{' '}
          de GMV
        </div>
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {general.take_rate_cdpl?.toFixed(1)}%
          </span>{' '}
          Take rate
        </div>
      </div>
    </DataCard>
    <DataCard title="Archi Interne" timeData="month">
      <div className="text-h5 lg-desktop:text-h4">
        <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
          {displayMoney(general.rev_archi_interne_mois ?? 0)}{' '}
        </span>{' '}
        de revenus
      </div>
    </DataCard>
    <DataCard title="CDP" timeData="month" subTitle="Diffus/non diffus">
      <div className="text-h5 lg-desktop:text-h4">
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.rev_cdp_diffus_mois ?? 0)}{' '}
          </span>{' '}
          de revenus diffus
        </div>
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.rev_cdp_non_diffus_mois ?? 0)}{' '}
          </span>{' '}
          de revenus non diffus
        </div>
      </div>
    </DataCard>
    <DataCard title="CDPL" timeData="month" subTitle="Diffus/non diffus">
      <div className="text-h5 lg-desktop:text-h4">
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.rev_cdpl_diffus_mois ?? 0)}{' '}
          </span>{' '}
          de revenus diffus
        </div>
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.rev_cdpl_non_diffus_mois ?? 0)}{' '}
          </span>{' '}
          de revenus non diffus
        </div>
      </div>
    </DataCard>
    <DataCard title="TP" timeData="month">
      <div className="text-h5 lg-desktop:text-h4">
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.tp_fees_cdp_mois)}{' '}
          </span>{' '}
          de revenus CDP
        </div>
        <div>
          <span className="text-brand font-semibold text-h4 lg-desktop:text-h3">
            {displayMoney(general.tp_fees_cdpl_mois)}{' '}
          </span>{' '}
          de revenus CDPL
        </div>
      </div>
    </DataCard>
  </div>
);
